import { useContext, useEffect, useState } from 'react';
import { useLoaderData, useNavigate } from 'react-router-dom';
import { useImmerReducer } from 'use-immer';
import PageBuilder from '../../../../library/Builders/PageBuilder/PageBuilder';
import { GlobalContext } from '../../../../library/Core/GlobalContext';
import { SmartContext } from '../../../../library/Core/SmartContext';
import smartReducer from '../../../../library/Core/SmartReducer';
import { DispatchEvent, State } from '../../../../library/Core/SmartTypes';
import { addUserSpecificDomains, getinstituteList } from '../../../../library/Service/domainService';
import { handleNext } from './RecruiterBasicInfoActions';
import SessionContext from '../../../../library/Core/SessionContext';
import { getMenuType } from '../../../../library/Core/SmartFunctions';
import RecruiterBasicInfoLayout from './RecruiterBasicInfoLayout';
import useManagementDashboard from '../../../management/dashboard/useManagementDashboard';

const RecruiterBasicInfo = () => {
    const { globalState } = useContext(GlobalContext);
    const { sessionState, sessionDispatch } = useContext(SessionContext);
    const { formConfig, data, routeInfo } = useLoaderData() as State;

    const navigate = useNavigate();
    const [redirectUrl, setRedirectUrl] = useState('');
    const [menuType, setMenuType] = useState(getMenuType(data));
    const { getCampusesUserWise } = useManagementDashboard();
    const [state, dispatch] = useImmerReducer<State, DispatchEvent>(smartReducer, {
        flags: { isDataLoading: true, showFormErrors: 0 },
        formValidationErrors: {},
        actions: { SAVE: handleNext, ROUTER_NAVIGATE: navigate, REDIRECT: setRedirectUrl, SET_MENU_TYPE: setMenuType },
    } as any);

    console.log("state?.data",data?.userInstitutes)
    const campuses = getCampusesUserWise(data?.userInstitutes);
    console.log("campuses",campuses.length)
    const [instituteList, setinstituteList] = useState(getinstituteList('INSTITUTE_GROUP_CODE', campuses));

    console.log("instituteList",instituteList)

    useEffect(() => {
        const domainMap = new Map([...globalState.domain])
        const domain = addUserSpecificDomains(new Map([...domainMap]), data);
        
        domain.set('INSTITUTE_USERWISE_CODE', instituteList);
       
        dispatch({
            type: 'DATA_INIT',
            payload: {
            formConfig: formConfig,
            data: {
                ...data,
                instituteIdlength: instituteList.length,
                recruiterJobs: (data?.recruiterJobs?.length
                ? data.recruiterJobs.map((job:any) => ({
                    ...job,
                     instituteId: job?.instituteId ?? instituteList[0]?.code,
                    }))
                : [{
                      instituteId: data?.recruiterJobs?.instituteId ?? instituteList[0]?.code,
                    }]
                ),
            },
            domain,
            routeInfo,
            },
            });

    }, []);

    useEffect(() => {
        // Add More each recruiterJob always has a default instituteId
        if (!state?.data?.recruiterJobs || instituteList.length === 0) return;

        const updatedJobs = state.data.recruiterJobs.map((job: any) => {
            if (!job?.instituteId) {
                return {
                    ...job,
                    instituteId: instituteList[0]?.code ?? '',
                };
            }
            return job;
        });
        const isChanged = JSON.stringify(updatedJobs) !== JSON.stringify(state.data.recruiterJobs);
        if (isChanged) {
            dispatch({
                type: 'DATA_INIT',
                payload: {
                    ...state,
                    data: {
                        ...state.data,
                        recruiterJobs: updatedJobs,
                    },
                },
            });
        }
    }, [state?.data?.recruiterJobs, instituteList]);

    useEffect(() => {
        if (redirectUrl !== '') {
            navigate(redirectUrl);
        }
    }, [redirectUrl]);

    useEffect(() => {
        let sessionData = { ...sessionState }
        sessionData.menuType = menuType;
        sessionDispatch({ type: 'SET', payload: sessionData });
    }, [menuType]);

    return (
        <SmartContext.Provider value={{ state, dispatch }}>
            <RecruiterBasicInfoLayout>{!state.flags.isDataLoading && <PageBuilder />}</RecruiterBasicInfoLayout>
        </SmartContext.Provider>
    );
};

export default RecruiterBasicInfo;
